import * as moment from 'moment';
import {ActionCompletionDialogComponent} from '../action-completion-dialog/action-completion-dialog.component';
import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IOrderDetails} from '../../models/models';
import {LoadingService} from '../../services/loading.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatCheckboxChange, MatStepper} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {PurchaseOrdersService} from '../../services/purchase-orders.service';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
  styleUrls: ['./create-loading-request.component.scss'],
  templateUrl: './create-loading-request.component.html'
})
export class CreateLoadingRequestComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('stepper', {static: false}) stepper: MatStepper;

  private requestDetails: any;
  private salePointID: any;
  private selectedSalePoint: any;
  private vendor: any;
  public dataSource: MatTableDataSource<any>;
  public deliveryPointsRecipients: any;
  public displayedColumns: string[];
  public extraInfoForOrder: any[];
  public firstFormGroup: FormGroup;
  public isLinear: true;
  public loadingOrderDetailsColumns: string[];
  public needsPurchaseOrderSelection = false;
  public orderData: any;
  public orderSelection: SelectionModel<IOrderDetails>;
  public poDetailsDataSource = new MatTableDataSource<IOrderDetails>();
  public purchaseOrderDetails: any[] = [];
  public secondFormGroup: FormGroup;
  public selectedPurchaseOrder: any;
  public selectedPurchaseOrderDetails: any[] = [];
  public selectRecipients: FormGroup;
  public selectedRecipient: any;
  public selectedSender: string;
  public selection: SelectionModel<any>;
  public step1Title: string;
  public step2Title: string;
  public title: string;
  public selectedOrder: any;

  constructor(private commonService: CommonService,
              private formBuilder: FormBuilder,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<CreateLoadingRequestComponent>,
              private purchaseOrdersService: PurchaseOrdersService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    const type = this.data.type === 1 ? `Αριθμό Παραγγελίας ${this.data.purchaseDocument}` : `Αριθμό Αίτησης ${this.data.order_id}`;
    this.title = `Νέα Εντολή Φόρτωσης για τον ${type}`;

    this.step1Title = this.data.type === 1 ? `Επιλέξτε κατηγορία παραλήπτη και ημερομηνία` : `Επιλέξτε ημερομηνία`;
    this.step2Title = this.data.type === 1 ? `Επιλέξτε παραλήπτη` : `Επιλέξτε αποστολέα`;

    this.loadingOrderDetailsColumns = this.data.type === 1 ? ['select', 'material_id', 'material_description', 'quantity_ordered',
      'loaded_quantity', 'loading_quantity'] : ['select', 'material_id', 'material_description', 'quantity_ordered',
      'approved_new', 'total_quantity_new', 'loaded_quantity_new', 'approved_used', 'total_quantity_used', 'loaded_quantity_used', 'loaded_quantity'];

    this.displayedColumns = this.data.type === 1 ? ['select', 'customer_name', 'vat_number', 'city',
      'address', 'phone_number1', 'type_name'] : ['select', 'name', 'role_name', 'status_name'];

    this.selection = new SelectionModel<any>(true, []);
    this.orderSelection = new SelectionModel<IOrderDetails>(true, []);

    this.requestDetails = JSON.parse(localStorage.getItem('requestDetails'));
    this.salePointID = this.data.sale_point_id;
    this.matDialogRef.updateSize('300px', '550px');
    this.extraInfoForOrder = [];
    this.orderData = [];
    this.selectedOrder = {};
  }

  public ngOnInit(): void {
    if (this.data.type === 1) {
      this.initRecipients();
      this.initVendor();
      this.selectRecipients = this.formBuilder.group({
        recipient: ['', Validators.required],
        delivery_date: ['', Validators.required]
      });
    } else {
      this.selectRecipients = this.formBuilder.group({
        delivery_date: ['', Validators.required]
      });
    }
    this.firstFormGroup = this.formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this.formBuilder.group({
      secondCtrl: ['', Validators.required]
    });

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.selectRecipients.controls.delivery_date.setValue(tomorrow);
  }

  private async initVendor() {
    const result = await this.commonService.getListWithParameters(`purchase_orders`, `purchasing_document=${this.data.purchaseDocument}`);
    this.vendor = result[0];
  }

  private async initRecipients() {
    try {
      // this.loadingService.show();
      const data = await this.purchaseOrdersService.getList('sale_point_category');
      if (this.data.type === 1) {
        this.deliveryPointsRecipients = data.filter(recipient => recipient.id !== 1 && recipient.id !== 5);
      } else {
        this.deliveryPointsRecipients = data.filter(recipient => recipient.id === 1 || recipient.id === 4);
      }
    } catch (e) {
    } finally {
      this.loadingService.hide();
    }
  }

  public applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  private initPaginatorAndSort() {
    this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.dataSource.sort = this.sort;
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    // @ts-ignore
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public isAllOrdersSelected(): boolean {
    const numSelected = this.orderSelection.selected.length;
    // @ts-ignore
    const numRows = this.poDetailsDataSource.data.length;
    return numSelected === numRows;
  }

  public masterToggle(): void {
    // @ts-ignore
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  public masterOrderToggle(): void {
    // @ts-ignore
    this.isAllSelected() ? this.orderSelection.clear() : this.poDetailsDataSource.data.forEach((row) => this.orderSelection.select(row));
  }

  selectRow(row: any) {
    this.selection.clear();
  }

  isRecipientFormValid(): boolean {
    return !this.selectRecipients.valid;
  }

  public async next() {

    if (this.stepper.selectedIndex === 0) {
      if (this.data.type === 1) {
        this.selectedRecipient = this.selectRecipients.get('recipient').value;
        const filter = this.selectedRecipient.id === 1 ? `(account_group_id <> 3000 AND account_group_id <> 3009) AND (sales_organization_id = 1000 OR sales_organization_id = 2000)` : this.selectedRecipient.id === 4 ? `(account_group_id = 3000 OR account_group_id = 3009)` : `category_id=${this.selectedRecipient.id}`;
        // this.loadingService.show();
        const result = await this.purchaseOrdersService.getList('sale_point', filter);

        this.dataSource = new MatTableDataSource<any>(result);
        this.initPaginatorAndSort();
        this.loadingService.hide();
      } else {
        const users = this.data.users.filter(u => u.status_value === 1);
        this.dataSource = new MatTableDataSource<any>(users);
        this.initPaginatorAndSort();
      }
      this.stepper.next();
    } else if (this.stepper.selectedIndex === 1) {
      this.selectedSalePoint = this.selection.selected;
      if (this.data.type === 1) {
        // this.loadingService.show();
        try {
          this.orderData = await this.commonService.getSimpleList(`po_details/${this.data.order_id}`);
          this.orderData.forEach(d => {
            d.loaded_quantity = d.loaded_quantity === null ? 0 : d.loaded_quantity;
          });
          this.poDetailsDataSource.data = this.orderData;
          this.stepper.next();
        } catch (e) {
        } finally {
          this.loadingService.hide();
        }
      } else {
        try {
          this.loadingService.show();
          if (this.selectedSalePoint[0].role_alternate_name
            && this.selectedSalePoint[0].role_alternate_name === 'manufacturingCompanyRepresentative') {
            this.needsPurchaseOrderSelection = true;
            this.selectedSender = 'manufacturingCompanyRepresentative';
            this.extraInfoForOrder = await this.commonService.insertObject(`po_details`, {
              vendor_id: this.selectedSalePoint[0].id,
              request_id: this.data.order_id
            });
          } else {
            this.selectedSender = '';
            this.needsPurchaseOrderSelection = false;
          }
          const data = await this.purchaseOrdersService.getList('request/web/details', `request_id=${this.data.order_id} AND (sales_inspector_action_id <> 2 OR sales_inspector_action_id is null)`);
          data.forEach(d => {
            d.total_quantity_new = 0;
            d.total_quantity_used = 0;
            d.loaded_quantity = d.loaded_quantity === null ? 0 : d.loaded_quantity;
          });
          data.forEach(d => {
            d.quantity_ordered = d.quantity;
          });
          if (this.needsPurchaseOrderSelection && data.find(d => d.has_new_refrigerators === 0)) {
            this.needsPurchaseOrderSelection = false;
          }
          this.poDetailsDataSource.data = data;
          this.loadingService.hide();
          this.stepper.next();
        } catch (e) {
        } finally {
          this.loadingService.hide();
        }
      }
    }
  }

  checkboxLabel(row?: IOrderDetails): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.orderSelection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

  public previous() {
    if (this.stepper.selectedIndex === 1) {
      this.selection.clear();
      this.stepper.previous();
    } else if (this.stepper.selectedIndex === 2) {
      this.stepper.previous();
    }
  }

  selectionChanged($event: MatCheckboxChange, row) {
    if ($event.checked === false) {
      return this.selection.deselect(row);
    } else {
      return this.selection.select(row);
    }
  }

  public isLoadingValid(): boolean {
    let valid = true;
    if (this.data.type === 1) {
      this.orderSelection.selected.forEach(selectedItem => {
        const quantity = selectedItem.loading_quantity;
        if (quantity === null || !quantity) {
          valid = false;
        }
      });
    } else if (this.needsPurchaseOrderSelection) {
      this.orderSelection.selected.forEach(selectedItem => {
        const hasPurchaseOrderDetail = this.selectedPurchaseOrderDetails &&
          this.selectedPurchaseOrderDetails.length > 0 ? this.selectedPurchaseOrderDetails.find(p => p.material_id === selectedItem.material_id
        && p.quantity_left >= selectedItem.total_quantity_new) : null;
        const quantityNew = selectedItem.approved_new > 0
          && (+selectedItem.total_quantity_new === 0 || selectedItem.total_quantity_new === null) ? null : selectedItem.total_quantity_new;
        const quantityUsed = selectedItem.total_quantity_used;
        selectedItem.delivery_schedule_id = hasPurchaseOrderDetail ? hasPurchaseOrderDetail.delivery_schedule_id : null;
        selectedItem.po_detail_id = hasPurchaseOrderDetail ? hasPurchaseOrderDetail.id : null;
        if ( !hasPurchaseOrderDetail || ((quantityNew === null || !quantityNew) && (quantityUsed === null || !quantityUsed))) {
          valid = false;
        }
      });
    } else {
      this.orderSelection.selected.forEach(selectedItem => {
        const quantityNew = selectedItem.total_quantity_new;
        const quantityUsed = selectedItem.total_quantity_used;
        if ((quantityNew === null || !quantityNew) && (quantityUsed === null || !quantityUsed)) {
          valid = false;
        }
      });
    }

    return !(valid && this.orderSelection.selected.length > 0);
  }

  public updateData(index: number, event: any): void {
    const value = event.target.value;
    if (index !== -1) {
      this.poDetailsDataSource.data[index].loading_quantity = value ? value : '';
    }
  }

  isRecipientsValid(): boolean {
    return this.selection.selected.length === 0;
  }

  public canShowForm() {
    if (this.data.type === 2) {
      if (this.needsPurchaseOrderSelection) {
        return this.extraInfoForOrder.length > 0;
      }
    }
    return true;
  }

  public onPurchaseOrderSelection(order: any) {
    this.selectedPurchaseOrderDetails = [];
    this.selectedOrder = order;
    this.purchaseOrderDetails = order.details;
  }

  public isOptionDisabled(option): boolean {
    const item = this.poDetailsDataSource.data.find(d => d.material_id === option.material_id);
    if (item) {
      return item.approved_new - item.loaded_quantity_new > option.quantity_left;
    }
  }

  public async submitLoading() {
    this.loadingService.show();
    const loadingModel = {
      user_id: this.data.type === 1 ? this.vendor.vendor_user_id : this.selectedSalePoint[0].id,
      order_id: this.data.order_id,
      order_type_id: this.data.type,
      type_id: this.data.type_id,
      sale_point_id: this.data.type === 1 ? this.selectedSalePoint[0].id : this.salePointID,
      desired_delivery_date: moment(this.selectRecipients.get('delivery_date').value).format('YYYY-MM-DD'),
      command_type: 0,
      command_id: null,
      materials: []
    };

    this.orderSelection.selected.forEach(selectedItem => {
      if (this.data.type === 1) {
        const model = {
          material_id: selectedItem.material_id,
          total_quantity: selectedItem.loading_quantity,
          delivery_schedule_id: selectedItem.delivery_schedule_id
        };
        loadingModel.materials.push(model);
      } else {
        const model = {
          material_id: selectedItem.material_id,
          total_quantity_new: selectedItem.total_quantity_new,
          total_quantity_used: selectedItem.total_quantity_used,
          caps: selectedItem.has_caps,
          bars: selectedItem.has_bars,
          cases: selectedItem.has_cases,
          request_detail_id: selectedItem.id,
          po_detail_id: this.needsPurchaseOrderSelection ? selectedItem.po_detail_id : null,
          delivery_schedule_id: this.needsPurchaseOrderSelection ? selectedItem.delivery_schedule_id : null,
          po_id: this.selectedOrder ? this.selectedOrder.id : null
        };
        loadingModel.materials.push(model);
      }
    });

    try {
     const result = await this.purchaseOrdersService.storeLoadingCommand('loading_command', loadingModel);
      this.loadingService.hide();
      this.matDialogRef.close(result);

      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις εντολές φόρτωσης',
          redirectURL: `loading_orders`
        }
      });
      this.loadingService.hide();
    } catch (e) {
      this.loadingService.hide();
      this.matDialogRef.close();
    }
  }

  selectRow1(row: any) {
    const oldSelected = this.selection.selected;
    if (oldSelected.length > 0) {
      this.selection.clear();
      this.selection.toggle(row);
    }
    if (oldSelected[0] === row || oldSelected.length === 0) {
      this.selection.toggle(row);
    }
  }
}
